/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load OpenAI event listeners
 *
 * https://developers.openai.com/ads/measurement-pixel
 * https://developers.openai.com/ads/conversions-api
 * https://developers.openai.com/ads/supported-events
 * */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", () => {
	if (pmwDataLayer?.pixels?.openai?.pixel_id && !pmwDataLayer?.pixels?.openai?.loaded) {
		if (pmw.consent.canPixelBeFired("marketing", "OpenAI")) pmw.loadOpenAIPixel();
	}
});

// page_viewed event (Server-to-Server)
pmw.bus.on("pmw:pixel:page-view", (payload) => {

	try {
		if (pmw.canNotFireOpenAIEvent()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "openai")) return;

		const openaiData = payload.pixels?.openai;
		if (!openaiData) return;

		oaiq("measure", openaiData.event_name, openaiData.event_data, { event_id: openaiData.event_id });
		pmw.console.log("OpenAI Pixel: page_viewed event sent", openaiData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// items_added event (Server-to-Server)
pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {

	try {
		if (pmw.canNotFireOpenAIEvent()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "openai")) return;

		const openaiData = payload.pixels?.openai;
		if (!openaiData) return;

		oaiq("measure", openaiData.event_name, openaiData.event_data, { event_id: openaiData.event_id });
		pmw.console.log("OpenAI Pixel: items_added event sent", openaiData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// contents_viewed event (Server-to-Server)
pmw.bus.on("pmw:pixel:view-item", (payload) => {

	try {
		if (pmw.canNotFireOpenAIEvent()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "openai")) return;

		const openaiData = payload.pixels?.openai;
		if (!openaiData) return;

		oaiq("measure", openaiData.event_name, openaiData.event_data, { event_id: openaiData.event_id });
		pmw.console.log("OpenAI Pixel: contents_viewed event sent", openaiData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// checkout_started event (Server-to-Server)
pmw.bus.on("pmw:pixel:begin-checkout", (payload) => {

	try {
		if (pmw.canNotFireOpenAIEvent()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "openai")) return;

		const openaiData = payload.pixels?.openai;
		if (!openaiData) return;

		oaiq("measure", openaiData.event_name, openaiData.event_data, { event_id: openaiData.event_id });
		pmw.console.log("OpenAI Pixel: checkout_started event sent", openaiData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// order_created event (Server-to-Server)
pmw.bus.on("pmw:pixel:purchase", (payload) => {

	try {
		if (pmw.canNotFireOpenAIEvent()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "openai")) return;

		const openaiData = payload.pixels?.openai;
		if (!openaiData) return;

		oaiq("measure", openaiData.event_name, openaiData.event_data, { event_id: openaiData.event_id });
		pmw.console.log("OpenAI Pixel: order_created event sent", openaiData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// registration_completed event (Server-to-Server)
pmw.bus.on("pmw:pixel:account-created", (payload) => {

	try {
		if (pmw.canNotFireOpenAIEvent()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "openai")) return;

		const openaiData = payload.pixels?.openai;
		if (!openaiData) return;

		oaiq("measure", openaiData.event_name, openaiData.event_data, { event_id: openaiData.event_id });
		pmw.console.log("OpenAI Pixel: registration_completed event sent", openaiData.event_data);

	} catch (e) {
		console.error(e);
	}
});

/**
 * Relay marketing consent changes to the SDK.
 *
 * The pixel is only loaded once marketing consent is granted, but a visitor
 * can withdraw it later in the cookie banner. oaiq("consent", false) stops
 * the SDK from sending measurement pings (blocked events are not replayed);
 * loadOpenAIPixel() resets a remembered denial when consent is granted again.
 * https://developers.openai.com/ads/measurement-pixel
 */
document.addEventListener("pmw:consent:update", ({ detail }) => {

	try {
		if (!pmwDataLayer?.pixels?.openai?.loaded) return;

		const granted = !!detail?.marketing;

		oaiq("consent", granted);
		pmw.console.log("OpenAI Pixel: consent updated: " + (granted ? "granted" : "denied"));

	} catch (e) {
		console.error(e);
	}
}, true);

// Note: order_created S2S is also handled automatically via WooCommerce order hooks on the server-side
